import { render, staticRenderFns } from "./ProductStockCloseForm.vue?vue&type=template&id=a9b16bd0"
import script from "./ProductStockCloseForm.vue?vue&type=script&lang=js"
export * from "./ProductStockCloseForm.vue?vue&type=script&lang=js"
import style0 from "./ProductStockCloseForm.vue?vue&type=style&index=0&id=a9b16bd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports